import axios from "axios";
const config = require("@/../config.js");

axios.defaults.withCredentials = true;
window.APP_ENDPOINT =
  process.env.NODE_ENV === "production" ? config.prod_host : config.host;

function resOk(res) {
  return res;
}

function resError(err) {
  let message = err.message;
  if (err.response && err.response.data && err.response.data.msg)
    message = err.response.data.msg;

  if (message) {
    // Store.commit('pushNotification', {
    //   verticalAlign: 'top',
    //   horizontalAlign: 'center',
    //   message: message,
    //   msg_type: 'danger',
    //   icon: 'add_alert'
    // });
  }

  return Promise.reject(err);
}

export default () => {
  let host = (process.env.NODE_ENV === "production") ? config.prod_host : config.host;
  const instance = axios.create({
    baseURL: host
  });
  instance.interceptors.response.use(resOk, resError);
  return instance;
};
